import React from 'react'
import {Link} from 'react-router'

export default {
  login: 'Entrar',
  email: 'Email',
  twoFactor: 'Two factor code',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña',
  register: 'Registrarse',
  country: 'País',
  passwordDoesntMatch: 'Las contraseñas no coinciden',
  otherLinksInRegister: () => (
    <div>
      Si ya tienes cuenta <Link to="/login">entra</Link>
    </div>
  ),
  otherLinksInLogin: () => (
    <div>
      ¿Nuevo en Orionx? <Link to="/register">Registrarme</Link>. ¿Has{' '}
      <Link to="/forgot">olvidado tu contraseña?</Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/pages/es.js